import React from "react";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TransactionType from "../../constants/TransactionTypes";
import CollectionOverride from "components/CollectionOverride";



export default class ProductsHistories extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Bound_Books_Products._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "ID",
				accessor: "transaction_in_id",
				/**
				 * @param {Bound_Books_Products_Object} props.original
				 * @returns {JSX.Element}
				 */
				Cell: props => <Link
					to={"/" + (props.original.transaction_in_type.toString() === '5' ? "losses" : TransactionType[props.original.transaction_in_type].toLowerCase() + "s") + "/" + props.original.transaction_in_binary_id + '-' + props.original.transaction_in}>{props.original.transaction_in_id ? props.original.transaction_in_id : (props.original.transaction_in_binary_id + '-' + props.original.transaction_in)}</Link>
			},
			{
				Header: "Type",
				id: "transaction_in_type",
				/** @param {Bound_Books_Products_Object} obj */
				accessor: obj => TransactionType[obj.transaction_in_type]
			},
			{
				Header: "Date",
				id: "date_in",
				width: 160,
				/** @param {Bound_Books_Products_Object} obj */
				accessor: obj => {
					return obj.date_in ? moment(obj.date_in)
						.local()
						.format("MM/DD/YYYY") : 'Never Acquired'
				}
			},
			{
				Header: "ID",
				accessor: "transaction_out_id",
				/**
				 * @param {Bound_Books_Products_Object} props.original
				 * @returns {JSX.Element}
				 */
				Cell: props => props.original.transaction_out ? <Link
					to={"/" + (props.original.transaction_out_type.toString() === '5' ? "losses" : TransactionType[props.original.transaction_out_type].toLowerCase() + "s") + "/" + props.original.transaction_out_binary_id + '-' + props.original.transaction_out}>{props.original.transaction_out_id ? props.original.transaction_out_id : (props.original.transaction_out_binary_id + '-' + props.original.transaction_out)}</Link> : null
			},
			{
				Header: "Type",
				id: "transaction_out_type",
				/** @param {Bound_Books_Products_Object} obj */
				accessor: obj => TransactionType[obj.transaction_out_type]
			},
			{
				Header: "Date",
				id: "date_out",
				width: 160,
				/** @param {Bound_Books_Products_Object} obj */
				accessor: obj => {
					return obj.date_out ? moment(obj.date_out)
						.local()
						.format("MM/DD/YYYY") : ''
				}
			},
			{
				Header: "Address",
				accessor: "out_to_address",
			},
			{
				Header: "NICS",
				accessor: "nics",
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/**
				 * @param {Bound_Books_Products_Object} props.original
				 * @returns {JSX.Element}
				 */
				Cell: props => {
					return (
						<span>
							<Link
								to={"/" + (props.original.transaction_in_type.toString() === '5' ? "losses" : TransactionType[props.original.transaction_in_type].toLowerCase() + "s") + "/" + props.original.transaction_in_binary_id + '-' + props.original.transaction_in}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className="fa fa-download"/>
								</Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/**
				 * @param {Bound_Books_Products_Object} props.original
				 * @returns {JSX.Element}
				 */
				Cell: props => {
					if (!props.original.transaction_out) {
						return null
					}
					return (
						<span>
							<Link
								to={"/" + (props.original.transaction_out_type.toString() === '5' ? "losses" : TransactionType[props.original.transaction_out_type].toLowerCase() + "s") + "/" + props.original.transaction_out_binary_id + '-' + props.original.transaction_out}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className="fa fa-upload"/>
								</Button>
							</Link>
						</span>
					);
				}
			},
		];

		// let transactionType = '';
		// /** @param {Bound_Books_Products_Object} obj */
		// switch(obj.transaction_in_type) {
		// 	case 1:
		// 		transactionType = 'Acquisitions';
		// 	case 2:
		// 		transactionType = 'Dispositions';
		// 	case 3:
		// 		transactionType = 'Transfers';
		// 	case 4:
		// 		transactionType = 'Destroys';
		// 	case 5:
		// 		transactionType = 'Losses';
		// 	case 6:
		// 		transactionType = 'Reservations';
		// 	case 7:
		// 		transactionType = 'Rentals';
		// 	default:
		// 		transactionType = '';
		// }

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Product History', "")}
								{this.renderHeaderRight("Product History", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
